import { reactular } from '@vendhq/reactular'
import { AblyProvider, ChannelProvider } from 'ably/react'
import React from 'react'
import { useAppSelector } from '../../state/hooks'
import {
  selectActiveOutletId,
  selectActiveRegisterId,
} from '../../state/slices/posState/posStateSlice'
import { getFeatureFromCache } from '../../util/feature-cache'
import { SaleChangeEvents } from '../sale/sale-change-listener/sale-change-listener'
import { RealtimeProvider, useRealtimeProvider } from './RealtimeProvider'

const FEATURE_CFD_ENABLED = 'lspay_customer_facing_display_enabled'

const RealtimeAblyEventHandler: React.FC = () => {
  const { client, serialNumber } = useRealtimeProvider()
  const cfdFeatureEnabled = getFeatureFromCache(FEATURE_CFD_ENABLED)

  if (!client || !serialNumber) {
    return null
  }

  const channelName = `lspay:terminal:${serialNumber}`

  return (
    <AblyProvider client={client}>
      <ChannelProvider channelName={channelName}>
        {cfdFeatureEnabled && <SaleChangeEvents channelName={channelName} />}
      </ChannelProvider>
    </AblyProvider>
  )
}

export const RealtimeEventHandler: React.FC = () => {
  const outletId = useAppSelector(selectActiveOutletId)
  const registerId = useAppSelector(selectActiveRegisterId)
  const cfdFeatureEnabled = getFeatureFromCache(FEATURE_CFD_ENABLED)

  // Add more features here as they are added
  const allFeaturesDisabled = !cfdFeatureEnabled

  if (!outletId || !registerId || allFeaturesDisabled) {
    return null
  }

  return (
    <RealtimeProvider outletId={outletId} registerId={registerId}>
      <RealtimeAblyEventHandler />
    </RealtimeProvider>
  )
}

export const ReactRealtimeEventHandlerComponent = reactular(
  RealtimeEventHandler,
  [],
  'reactWrapper'
)
